import { createAction, props } from '@ngrx/store';

export const BackEntitiesSelectionChanged = createAction(
    '[BACK-ENTITIES-SELECTION] Changed',
    props<{ key: string, all: boolean, entityIds: string[] }>()
);

export const BackEntitiesSelectionResetRequested = createAction(
    '[BACK-ENTITIES-SELECTION] Reset Requested'
);
